import { HashMap } from '../../constants';
import { AsyncLoadableObject, ExpiringObject, Loadable } from '../../models';
import { QueryResult } from '../../models/queryResult';
import { ComplexSearchFilter, SimSubmissionComplexSearchFilter } from '../../models/searchFilter';
import { Sim } from '../sim';
import { SimSubmission } from '../transfer/input/SimSubmission';

/**
 * The number of seconds the application will wait before refreshing SIM submissions from the server.
 */
export const SimSubmissionsCacheTimeout = 3600;

export type SubmissionsState = Loadable<{
  /** The search filter */
  searchFilter: SimSubmissionComplexSearchFilter;

  /** An array containing a flat list of all the loaded SIM submissions. */
  all: QueryResult<SimSubmission>;

  /** An array containing a flat list of all the loaded SIM submissions, organized by identifier. */
  submissionsByTicketNumber: HashMap<SimSubmission>;

  /** The currently selected submission ticket number. */
  selected?: string;
}>;

export const getDefaultSubmissionsState = (): SubmissionsState => {
  return {
    searchFilter: {
      companyId: 0,
      filters: {},
      sortModel: [{ colId: 'createdOn', sort: 'desc' }],
      searchType: 'serial',
    },
    all: {
      result: [],
    },
    submissionsByTicketNumber: {},
    isLoading: false,
  };
};
